import React, { useState } from "react";
import { Dropdown, Input, Nav, Navbar } from "rsuite";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import * as userManager from "../../Services/UserSessionManager";
import { Link, useNavigate } from "react-router-dom";
import { ProfileDropDown } from "./ProfileDropDown";
import "./Home.css";
import { AppAdmin } from "./AppAdmin";
import { AppProfile } from "./AppProfile";
import { KRAMenu } from "./KRAMenu";
import { AdminReport } from "./AdminReport";
import { RoleChange } from "./RoleChange";
import { MyApps } from "./MyApps";
import { RoleChangeBIManager } from "./RoleChangeBIManager";
import { RoleChangeBIManagerAndEmployee } from "./RoleChangeBIManager&Employee";

export const AppNavBar = () => {
  const [checkRole, setCheckRole] = useState(userManager.GetUserRole());
  const [empId, setEmpId] = useState(userManager.GetUserLoginID());

  const [navBar, setNavBar] = useState([]);

  const handleChange = (event: any) => {
    setNavBar(event.target.innerText);
  };
  let navigate = useNavigate(); 
  return (
    <Navbar className="nav-bar-shadow stems-green-bg">
      <Navbar.Brand className="link-simple p-0">
        <Link to="/" className="link-simple">
          <img src="/stems-logo.png" className="logo-resized" />
        </Link>
      </Navbar.Brand>

      <Nav pullRight>
        <AppAdmin />
        <AdminReport />
        {checkRole == "H" ||
        checkRole == "M" ||
        checkRole == "A" ||
        checkRole == "PM" ||
        checkRole == "BI" ||
        checkRole == "QM" ? (
          <Dropdown
            title={"Team"}
            className="nav-bar-text-white"
            icon={
              <BootstrapIcon
                cssClasses="p-2 nav-bar-text-white"
                bootStrapIconName="person-lines-fill"
                size={18}
              />
            }
          >
            {checkRole == "A" ||
            checkRole == "H" ||
            checkRole == "M" ||
            checkRole == "PM" ||
            checkRole == "BI" ||
            checkRole == "QM" ? (
              <Link className="link-simple" to={"/EmpoyeeDataList"}>
                <Dropdown.Item
                  icon={
                    <BootstrapIcon
                      bootStrapIconName={"people-fill"}
                      size={14}
                      cssClasses={"pe-2"}
                    />
                  }
                >
                  My Team
                </Dropdown.Item>
              </Link>
            ) : (
              <></>
            )}
            {checkRole == "QM" || checkRole == "A" || checkRole == "BI" ? (
              <Link className="link-simple" to={"/QMTeamReport"}>
                <Dropdown.Item
                  icon={
                    <BootstrapIcon
                      bootStrapIconName={"people"}
                      size={14}
                      cssClasses={"pe-2"}
                    />
                  }
                >
                  All Team
                </Dropdown.Item>
              </Link>
            ) : (
              <></>
            )}

            {checkRole == "H" ||
            checkRole == "A" ||
            checkRole == "M" ||
            checkRole == "QM" ||
            checkRole == "PM" ? (
              <Link className="link-simple" to={"/EmployeeDetails"}>
                <Dropdown.Item
                  icon={
                    <BootstrapIcon
                      bootStrapIconName={"gear-wide-connected"}
                      size={14}
                      cssClasses={"pe-2"}
                    />
                  }
                >
                  Manage Teams
                </Dropdown.Item>
              </Link>
            ) : (
              <></>
            )}

            {checkRole == "H" ||
            checkRole == "A" ||
            checkRole == "M" ||
            checkRole == "PM" ||
            checkRole == "QM" ||
            checkRole == "BI" ? (
              <Link className="link-simple" to={"/TeamDetails"}>
                <Dropdown.Item
                  icon={
                    <BootstrapIcon
                      bootStrapIconName={"person-check-fill"}
                      size={14}
                      cssClasses={"pe-2"}
                    />
                  }
                >
                  Team Allocation
                </Dropdown.Item>
              </Link>
            ) : (
              <></>
            )}

            {checkRole == "H" ||
            checkRole == "A" ||
            checkRole == "M" ||
            checkRole == "PM" ||
            checkRole == "QM" ||
            checkRole == "BI" ? (
              <Link className="link-simple" to={"/ManagerProcess"}>
                <Dropdown.Item
                  icon={
                    <BootstrapIcon
                      bootStrapIconName={"person-workspace"}
                      size={14}
                      cssClasses={"pe-2"}
                    />
                  }
                >
                  Buffer Report (Manager/Process)
                </Dropdown.Item>
              </Link>
            ) : (
              <></>
            )}

            {checkRole == "H" ||
            checkRole == "A" ||
            checkRole == "M" ||
            checkRole == "PM" ||
            checkRole == "QM" ||
            checkRole == "BI" ? (
              <Link className="link-simple" to={"/ProcessBuffer"}>
                <Dropdown.Item
                  icon={
                    <BootstrapIcon
                      bootStrapIconName={"people-fill"}
                      size={14}
                      cssClasses={"pe-2"}
                    />
                  }
                >
                  Buffer Report (Team/Process)
                </Dropdown.Item>
              </Link>
            ) : (
              <></>
            )}

            {checkRole == "H" ||
            checkRole == "A" ||
            checkRole == "M" ||
            checkRole == "PM" ||
            checkRole == "QM" ||
            checkRole == "BI" ? (
              <Link className="link-simple" to={"/LocationProcess"}>
                <Dropdown.Item
                  icon={
                    <BootstrapIcon
                      bootStrapIconName={"person-workspace"}
                      size={14}
                      cssClasses={"pe-2"}
                    />
                  }
                >
                  Buffer Report (Location/Process)
                </Dropdown.Item>
              </Link>
            ) : (
              <></>
            )}
          </Dropdown>
        ) : (
          <></>
        )}
        {empId === "2224" ||
        empId === "1507" ||
        empId === "2560" ||
        empId === "2195" ||
        empId === "1791" ||
        empId === "2975" ||
        empId === "003" ? (
          <RoleChange />
        ) : empId === "3134" || empId === "3133" || empId === "2052" ? (
          <RoleChangeBIManager />
        ) : empId === "2843" || empId === "3459" ? (
          <RoleChangeBIManagerAndEmployee />
        ) : (
          <></>
        )}

        <KRAMenu />
            <Dropdown title={"Idea Portal"}
              className="nav-bar-text-white"
             icon={<BootstrapIcon cssClasses="p-2 nav-bar-text-white" bootStrapIconName="lightbulb-fill" size={18} />}
              onClick={()=>navigate('/IdeasList')}
              noCaret>
              </Dropdown>
        <AppProfile />
        <ProfileDropDown />
      </Nav>
    </Navbar>
  );
};
